import { all } from 'redux-saga/effects'

import portfolioExportSaga from './components/ToolbarDesks/Exports/saga'

export default function* toolbarSaga() {
    yield all([portfolioExportSaga()])
}
